export default __webpack_public_path__ + "static/media/square-engine.24a58672.svg";